import PropTypes from 'prop-types';
import React from 'react';
import { IoIosClose as CloseIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  button: {
    color: '#FFFFFF',
    composes: ['fs20'],
  },
  header: {
    composes: ['mx12', 'mt12', 'mb0', 'text-right'],
  },
});

const RideTooltipFooterComponent = React.memo(({ skipProps }) => {
  const classes = useStyles();
  return (
    <div className={classes.header}>
      <button className={classes.button} type="button" {...skipProps}>
        <CloseIcon />
      </button>
    </div>
  );
});

RideTooltipFooterComponent.propTypes = {
  skipProps: PropTypes.shape().isRequired,
};

export default RideTooltipFooterComponent;
